export const Fields = {
  department: 'department',
  location: 'officeLocation',
  email: 'email',
  salary: 'salary',
  salaryNewRole: 'salary-newrole',
  name: 'name',
  plannedHireDate: 'planned-hire-date',
  planStatus: 'scenario-status',
  level: 'level',
  reportingLayers: 'reporting-layers',
  groupByRole: 'group-by-role',
  hierarchicalSpanOfControl: 'hierarchical-span-of-control',
  directManagerSpanOfControl: 'direct-manager-span-of-control',
  managerialSpanOfControl: 'managerial-span-of-control',
  managementCostEtihad: 'management-cost-etihad',
  vacancies: 'vacancies',
  role: 'role',
  managerCount: 'manager-count',
  managerCost: 'manager-cost',
  icCount: 'ic-count',
  icCost: 'ic-cost',
  managerCostRatio: 'management-cost-ratio',
  icCostRatio: 'ic-cost-ratio',
  managerICRatio: 'manager-ic-ratio',
  totalCost: 'total-cost',
  dottedLines: 'dotted-lines',
  rateCard: 'rate-card',
  jobCatalog: 'job-catalog',
  personId: 'person-id',
  payRateEffectiveDate: 'pay-rate-effective-date',
  displayedPositionId: 'displayed-position-id',
  sourceEmployeeId: 'source-employee-id',
  sourceScenario: 'source-scenario',
  averageSalary: 'average-salary',
  averageManagerSalary: 'average-manager-salary',
  averageICSalary: 'average-ic-salary',
  oneToOneManagers: 'one-to-one-managers',
  directSpanOfControl: 'direct-span-of-control',
  endDate: 'endDate',
  startDate: 'startDate',
  employeeSkillMatch: 'employee-skill-match',
  agentSkillMatch: 'agent-skill-match'
}

export const ManagementFields = [
  Fields.managerCount,
  Fields.managerCost,
  Fields.icCount,
  Fields.icCost,
  Fields.managerCostRatio,
  Fields.icCostRatio,
  Fields.managerICRatio,
  Fields.totalCost
]

// Per-position skill match percents from GET /spotlight/:boardId/skill-match
export const SkillMatchFields = [Fields.employeeSkillMatch, Fields.agentSkillMatch]

export const FieldsLabels = {
  [Fields.name]: 'Name',
  [Fields.department]: 'Department',
  [Fields.location]: 'Location',
  [Fields.email]: 'Email',
  [Fields.salary]: 'Salary',
  [Fields.salaryNewRole]: 'Salary (new role)',
  [Fields.plannedHireDate]: 'Hire date (new role)',
  [Fields.planStatus]: 'Scenario status',
  [Fields.level]: 'Layers',
  [Fields.groupByRole]: 'Group by: position',
  [Fields.hierarchicalSpanOfControl]: 'Average Hierarchical Span of Control',
  [Fields.directManagerSpanOfControl]: 'Average Direct Manager Span of Control',
  [Fields.managerialSpanOfControl]: 'Average Managerial Span of Control',
  [Fields.managementCostEtihad]: 'Management cost',
  [Fields.vacancies]: 'Vacancies',
  [Fields.reportingLayers]: 'Reporting layers',
  [Fields.role]: 'Position Title',
  [Fields.managerCount]: 'Manager count',
  [Fields.managerCost]: 'Manager cost',
  [Fields.icCount]: 'IC count',
  [Fields.icCost]: 'IC cost',
  [Fields.managerCostRatio]: 'Manager cost ratio',
  [Fields.icCostRatio]: 'IC cost ratio',
  [Fields.managerICRatio]: 'Manager to IC ratio',
  [Fields.totalCost]: 'Total cost',
  [Fields.dottedLines]: 'Dotted lines',
  [Fields.rateCard]: 'Rate card',
  [Fields.jobCatalog]: 'Job catalog',
  [Fields.personId]: 'Agentnoon ID',
  [Fields.payRateEffectiveDate]: 'Effective date',
  [Fields.displayedPositionId]: 'Agentnoon Position ID',
  [Fields.sourceEmployeeId]: 'Employee ID',
  [Fields.sourceScenario]: 'Source of Position',
  [Fields.averageSalary]: 'Average salary',
  [Fields.averageManagerSalary]: 'Average manager salary',
  [Fields.averageICSalary]: 'Average IC salary',
  [Fields.oneToOneManagers]: 'Number of 1-1 relationships',
  [Fields.directSpanOfControl]: 'Direct span of control',
  [Fields.endDate]: 'End date',
  [Fields.startDate]: 'Start date',
  [Fields.employeeSkillMatch]: 'Employee skill match',
  [Fields.agentSkillMatch]: 'Agent skill match'
}

export const metricsMap = [
  {
    key: 'reportingLayers',
    fieldId: Fields.reportingLayers,
    id: 'levelsOfManagement',
    name: 'Reporting layers'
  },
  {
    key: 'hierarchicalSpanOfControl',
    fieldId: Fields.hierarchicalSpanOfControl,
    id: 'hierarchicalSpanOfControl',
    name: 'Average Hierarchical SOC'
  },
  {
    key: 'directManagerSpanOfControl',
    fieldId: Fields.directManagerSpanOfControl,
    id: 'directManagerSpanOfControl',
    name: 'Average Direct Manager SOC'
  },
  {
    key: 'managerialSpanOfControl',
    fieldId: Fields.managerialSpanOfControl,
    id: 'managerialSpanOfControl',
    name: 'Average Managerial SOC'
  },
  {
    key: 'directSpanOfControl',
    fieldId: Fields.directSpanOfControl,
    id: 'direct-span-of-control',
    name: 'Direct span of control'
  },
  {
    key: 'averageSalary',
    fieldId: Fields.averageSalary,
    id: 'average-salary',
    name: 'Average salary'
  },
  {
    key: 'averageManagerSalary',
    fieldId: Fields.averageManagerSalary,
    id: 'average-manager-salary',
    name: 'Average manager salary'
  },
  {
    key: 'averageICSalary',
    fieldId: Fields.averageICSalary,
    id: 'average-ic-salary',
    name: 'Average IC salary'
  },
  {
    key: 'oneToOneManagers',
    fieldId: Fields.oneToOneManagers,
    id: 'one-to-one-managers',
    name: 'Number of 1-1 relationships'
  }
]

export const SpanOfControlMetricIds = new Set([
  'hierarchicalSpanOfControl',
  'directManagerSpanOfControl',
  'managerialSpanOfControl',
  'direct-span-of-control'
])

export const MetricIdByFieldId = new Map(metricsMap.map((metric) => [metric.fieldId, metric.id]))

export function getMetricIdsForFields(fields = [], customRules = []) {
  const metricIds = new Set()
  const customRuleIds = new Set(customRules.map((rule) => rule.id).filter(Boolean))

  for (const field of fields || []) {
    const metricId = MetricIdByFieldId.get(field)
    if (metricId) {
      metricIds.add(metricId)
      continue
    }

    if (customRuleIds.has(field)) {
      metricIds.add(field)
    }
  }

  return Array.from(metricIds)
}

export function getNonSpanMetricIdsForFields(fields = [], customRules = []) {
  return getMetricIdsForFields(fields, customRules).filter(
    (metricId) => !SpanOfControlMetricIds.has(metricId)
  )
}
